import { createContext,useEffect,useReducer } from "react";

export const StudentAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'STUDENT_LOGIN':
        return {studentuser: action.payload}

        case 'STUDENT_LOGOUT':
            return {
                studentuser:null,
            }

        default:
            return state;    
    }
}

export const StudentAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        studentuser:null
    });

    useEffect(()=>{
        const studentuser = JSON.parse(localStorage.getItem('studentuser'));
        if(studentuser){
            dispatch({type:'STUDENT_LOGIN', payload:studentuser});
        }

    },[]);

    console.log('StudentAuthContext State ', state);

    return (
        <StudentAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </StudentAuthContext.Provider>
    )
}
